export const EXTERNAL_URLS = {
  youtubeURL: "https://www.youtube.com/channel/UCWVgaECFNjMWDczgCTI4pFw",
  instagramURl:
    "https://www.instagram.com/accounts/login/?next=https%3A%2f%2fwww.instagram.com%2fdupontwatersolutions%2f&is_from_rle",
  linkedinURL: "https://www.linkedin.com/showcase/dupont-water-solutions",
};
export const FOOTER_URL = {
  en: {
    dupontUrl: "https://www.dupont.com/",
    privacyUrl: "https://www.dupont.com/privacy.html",
    termsConditions:
      "https://www.dupont.com/legal-notices-and-terms-of-use.html",
    a11yUrl: "https://www.dupont.com/accessibility.html",
  },
  zh: {
    dupontUrl: "https://www.dupont.cn/",
    privacyUrl: "https://www.dupont.cn/privacy.html",
    termsConditions:
      "https://www.dupont.cn/legal-notices-and-terms-of-use.html",
    a11yUrl: "https://www.dupont.cn/accessibility.html",
  },
};
